var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconMoveStartLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconMoveStart",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M114.063 276v1368.756H0V276h114.063Zm739.106 73.765 80.642 80.642-473.02 473.02H1920v113.948H460.792l473.02 473.02-80.643 80.642-610.694-610.693 610.694-610.58Z",
      fillRule: "evenodd"
    })));
  }
}
IconMoveStartLine.glyphName = 'move-start';
IconMoveStartLine.variant = 'Line';
IconMoveStartLine.displayName = 'IconMoveStartLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMoveStartLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMoveStartLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMoveStartLine;
export { IconMoveStartLine };